import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [121.34, 213.81, 364.8],
  minDistance: 200,
  maxDistance: 500,
  minAzimuthAngle: -Math.PI / 6,
  maxAzimuthAngle: Math.PI / 6,
  minPolarAngle: Math.PI / 2.5,
  maxPolarAngle: (85 * Math.PI) / 180,
  target: [20, 100, 0],
  getShadowManXPosition: (width: number) => -width / 2 - 50,
}
